import { gql } from '@apollo/client';
import { ssrApolloService } from '@scorenco/core';
import { ssrIsAuthenticated } from '@scorenco/next';

import { MobileLayout, createMobilePage } from '@/layouts';

const Index = createMobilePage();

export const getServerSideProps = MobileLayout.buildGetServerSideProps(
  {
    i18n: { defaultLocale: 'fr' },
  },
  [
    async ({ req, res, query }, previous) => {
      try {
        const authenticated = await ssrIsAuthenticated({
          request: req,
          response: res,
        });

        const clubId = query.clubId || Object.keys(query)[0];

        if (!authenticated && process.env.NODE_ENV !== 'development') {
          const { apolloClient } = ssrApolloService();

          const clubQuery = await apolloClient.query({
            query: gql`
              query GetClubSlugInfo($clubId: Int!) {
                clubs_club_by_pk(id: $clubId) {
                  url
                }
              }
            `,
            variables: { clubId: Number(clubId) },
          });
          const club = (
            clubQuery.data as { clubs_club_by_pk?: { url?: string } }
          ).clubs_club_by_pk;
          if (club) {
            return {
              redirect: {
                statusCode: 302,
                destination: `${process.env.NEXT_PUBLIC_WEB_URL}${club.url}`,
              },
            };
          }
        }
      } catch (e) {
        console.log('error : ', e);
      }

      return previous;
    },
  ]
);

export default Index;
